import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CollectionModel } from './models/collection.model';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { BookmarkModel } from '../bookmarks/models/bookmark.model';
import { BookmarksService } from '../bookmarks/bookmarks.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bookmarks/bookmarks.service";
/**
 * Collections service endpoint
 */
const collectionsURL = '/ws/enterprise/collection';
export class OrganizationsService {
    constructor(http, bookmarkService) {
        this.http = http;
        this.bookmarkService = bookmarkService;
    }
    getCollections(groupId) {
        return this.http.get(`${collectionsURL}?group_id=${groupId}`)
            .pipe(map((results) => {
            return plainToClass(CollectionModel, results)
                .map((collection) => this.normalizeCollectionModel(collection));
        }));
    }
    getCollectionsByContent(groupId, content, includeContent = false) {
        const { content_type, content_id } = content;
        const url = `${collectionsURL}?group_id=${groupId}&content_type=${content_type}&content_id=${content_id}&include_content=${includeContent ? 1 : 0}`;
        return this.http.get(url)
            .pipe(map((results) => {
            return plainToClass(CollectionModel, results)
                .map((collection) => this.normalizeCollectionModel(collection));
        }));
    }
    /**
     * Gets the collection content id by content
     */
    getCollectionContentId(collection, content) {
        const { content_type, content_id } = content;
        return this.getCollectionsByContent(collection.group_id, content, true)
            .pipe(
        // restrict to target collection
        map((collections) => collections.find((c) => c.collection_id === collection.collection_id)), map((c) => {
            let foundBookmark;
            if (c) {
                foundBookmark = c.collection_content.find((bookmark) => {
                    return content_type === 'module' ? content_id === bookmark.module_name : content_id === bookmark.id;
                });
            }
            return foundBookmark ? foundBookmark.collection_content_id : null;
        }));
    }
    /**
     * Gets an individual group collection.
     */
    getCollection(groupId, collectionId, includeContent) {
        return this.http.get(`${collectionsURL}?group_id=${groupId}&collection_id=${collectionId}&include_content=${includeContent ? 1 : 0}`)
            .pipe(map((collections) => {
            const collection = collections[0];
            return collection ? this.normalizeCollectionModel(collection) : collection;
        }));
    }
    /**
     * Gets the list of models in the specified collection.
     */
    getCollectionContent(groupId, collectionId, query = '') {
        const queryParts = query.toLocaleLowerCase().split(' ');
        return this.getCollection(groupId, collectionId, true)
            .pipe(map((result) => {
            // exclude unavailable
            return result.collection_content
                .map((bookmark) => plainToClass(BookmarkModel, bookmark))
                .filter((bookmark) => {
                let include = true;
                if (queryParts.length && bookmark.title) {
                    queryParts.forEach(queryPart => {
                        include = include && bookmark.title.toLocaleLowerCase().indexOf(queryPart) >= 0;
                    });
                }
                include = include && bookmark.unavailable !== true;
                return include;
            });
        }));
    }
    addToCollection(collection, models) {
        return this.formPost(collectionsURL, {
            group_id: collection.group_id,
            collection_id: collection.collection_id,
            add_content: models
        })
            .pipe(map((_collections) => {
            return _collections.map((_collection) => this.normalizeCollectionModel(_collection));
        }));
    }
    removeFromCollection(collection, collectionContentIds) {
        return this.formPost(collectionsURL, {
            group_id: collection.group_id,
            collection_id: collection.collection_id,
            remove_content: collectionContentIds
        })
            .pipe(map((_collections) => {
            return _collections.map((_collection) => this.normalizeCollectionModel(_collection));
        }));
    }
    getOrganizationAttribute(attributes, type, name) {
        return attributes.find((attribute) => attribute.type === type && attribute.name === name);
    }
    /**
     * Adds the current user to the specified organization (by organization's eid)
     */
    addUserToOrganization(group_eid) {
        return this.http.post(`/ws/enterprise/user/add`, { 'group_eid': group_eid });
    }
    addUserWithGroupCode(group_code) {
        return this.http.post(`/ws/enterprise/user/add`, { 'group_code': group_code });
    }
    normalizeCollectionModel(collection) {
        if (collection.collection_content) {
            collection.collection_content.forEach((bookmark) => {
                this.bookmarkService.normalizeBookmarkModel(bookmark);
            });
        }
        return collection;
    }
    // TODO: centralize form posting logic or migrate service to accept JSON
    formPost(url, payload) {
        const formHeaders = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
        const body = new URLSearchParams();
        Object.keys(payload).forEach((key) => {
            const value = payload[key];
            const encodedValue = `${value instanceof Object ? JSON.stringify(value) : value}`;
            body.set(key, encodedValue);
        });
        return this.http.post(`${url}`, body.toString(), formHeaders)
            .pipe(map((reponse) => reponse));
    }
}
OrganizationsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OrganizationsService_Factory() { return new OrganizationsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BookmarksService)); }, token: OrganizationsService, providedIn: "root" });
